import { Map } from "immutable";

import { SYNC_NARRATIVE_FOLDER_IDENTIFIER } from "../../constants/syncNarrativeFolderIdentifier";
// import getSubTreeWithId from "../../utils/tree/getSubTreeWithId";
import { default as syncSelectors } from "../../modules/sync/selectors";
import immutableRecords from "../../types/immutableRecords";
import syncDocumentFromItem from "./syncDocumentFromItem";
import syncDocumentFromNarrativeRoot from "./syncDocumentFromNarrativeRoot";
import updateDocumentTreeIds from "./updateDocumentTreeIds";

const syncRepresentationOfNarrative = (
  itemsById,
  typesById,
  relationshipsById,
  propertiesById,
  referencesById,
  colorsById,
  narrativeIds,
  documentTree,
  localToExternalIds,
  syncSettings,
  tagsById,
  calendar,
  externalRep
) => {
  if (!externalRep) {
    return null;
  }
  const narrativeFolderLabel = syncSelectors.getNarrativeFolderLabelFromSyncRep(externalRep, syncSettings);

  const result = immutableRecords.SyncRepresentationRecord({
    documents: Map(
      narrativeIds.map(id => {
        const externalId = localToExternalIds.has(id) ? localToExternalIds.get(id) : id;
        // Note: null for documentOrFolder just lets the function decide
        const documentOrFolder = null;
        return [
          externalId,
          syncDocumentFromItem(
            itemsById.get(id),
            externalId,
            documentOrFolder,
            syncSettings,
            itemsById,
            typesById,
            relationshipsById,
            propertiesById,
            referencesById,
            colorsById,
            tagsById,
            calendar,
            externalRep.customFields
          )
        ];
      })
    ).set(
      SYNC_NARRATIVE_FOLDER_IDENTIFIER,
      syncDocumentFromNarrativeRoot(SYNC_NARRATIVE_FOLDER_IDENTIFIER, narrativeFolderLabel)
    ),
    documentTree: updateDocumentTreeIds(documentTree, localToExternalIds).set("id", SYNC_NARRATIVE_FOLDER_IDENTIFIER),
    SYNC_NARRATIVE_FOLDER_IDENTIFIER
  });

  return result;
};

export default syncRepresentationOfNarrative;
